<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<style>
  *{
    margin: 0;
    padding: 0;
  }
  /* 清除浏览器默认样式(尤其safari) */
  select{
  	appearance:none;
  	-webkit-appearance:none;
  	-moz-appearance:none;
  	padding-left: 0.16rem !important;
  	background: #fff url(assets/systemImg/arrow_down.png) no-repeat !important;
	background-size: 0.12rem 0.06rem !important;
  	background-position: right center !important;
  }
  
  /* 表格字体大小统一设置 */
  .el-table td, 
  .el-table th{
  }
  .el-table .cell{
  }
  
  html,body{
	  width: 100%;
	  height: 100%;
	  
  }
  
  #app{
	  width: 100%;
	  height: 100%;
  }
  
  .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
	  border-right:none !important;
	  border-left:none !important;
  }
  
  .el-table--border, .el-table--group{
	  border: none !important;
  }
  
  .el-table--border::after, .el-table--group::after, .el-table::before{
	  background-color: transparent !important;
  }
  
  .el-table th>.cell{
	  font-weight: normal !important;
  }
  
  .el-table .cell{
	  font-size: 14px !important;
  }
  
  .el-input__inner{
	  height: 36px !important;
  }
  
  .el-pagination > button{
	  width: fit-content !important;
	  display: flex;
	  align-items: center;
  } 
  
  .el-pagination > button >span{
  	  
  } 
  
  .el-pagination .el-input__inner{
	  height: 28px !important;
  }
  
  .el-pagination .number{
  }
  
  
  .order_status_80 {
  	display: inline-block;
  	padding: 2px 8px;
  	border-radius: 4px;
  	color: #fff;
  	background-color: #5eb95e;
  }
  
  .pay_status_1 {
  	display: inline-block;
  	padding: 2px 8px;
  	border-radius: 4px;
  	color: #fff;
  	background-color: #dd514c;
  }
  .order_status_1 {
  	display: inline-block;
  	padding: 2px 8px;
  	border-radius: 4px;
  	color: #fff;
  	background-color: #F37B1D;
  }
  
</style>
<script>
  export default {
    name: 'App',
    provide () {
      return {
        reload: this.reload
      }
    },
    data () {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      reload () {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    }
  }
</script>